import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

const priceStyles = ({ theme }) => css`
  label: details__price;

  color: ${theme.colors.n400};
  display: block;
  margin-bottom: 1px;
`

const headerStyles = ({ theme }) => css`
  label: details__header;

  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;

  .glyph-trash-can {
    font-size: ${theme.typography.text.mega.fontSize};
  }
`

const deleteIconStyles = ({ theme }) => css`
  label: details__delete-icon;

  color: ${theme.colors.r500};
  cursor: pointer;
  height: ${theme.spacings.mega};
  outline: none;
  padding: 0;
  margin-left: 3%;
  width: ${theme.spacings.mega};
`

const shippingWrapperStyles = css`
  label: details__shipping-wrapper;

  display: flex;
  align-items: center;
  height: 100%;
`

const productInfoStyles = css`
  label: details__product-info;

  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
`

const priceTotalStyles = ({ theme }) => css`
  label: details__price-total;

  color: ${theme.colors.n800};
`

const anchorTitleStyles = ({ theme }) => css`
  label: details__anchor;

  font-size: ${theme.typography.text.kilo.fontSize};
  line-height: ${theme.typography.text.kilo.lineHeight};
  text-align: left;
  display: block;
  margin-bottom: ${theme.spacings.bit};
  color: ${theme.colors.p500};
`

const contentStyles = css`
  label: details__content;

  display: flex;
  line-height: 0;
  justify-content: space-between;
  align-items: stretch;
  margin-bottom: 3px;
`

const footerStyles = css`
  label: details__footer;

  display:flex;
  justify-content: space-between;
  align-items: center;
`

export const Header = styled('div')(headerStyles)
export const DeleteIcon = styled('button')(deleteIconStyles)
export const ShippingWrapper = styled('div')(shippingWrapperStyles)
export const Price = styled(Text)(priceStyles)
export const ProductDetails = styled('div')(productInfoStyles)
export const PriceTotal = styled(Text)(priceTotalStyles)
export const AnchorTitle = styled('a')(anchorTitleStyles)
export const Content = styled('div')(contentStyles)
export const Footer = styled('div')(footerStyles)
